import axios from "axios";

// A API agora roda dentro do próprio Next (src/pages/api/[[...path]].ts).
const api = axios.create({
  baseURL: "/api",
});

// No servidor (getStaticProps/getServerSideProps, `next build`, ISR) as chamadas para a própria
// API são despachadas em processo, sem HTTP. O Next troca `typeof window` por uma constante na
// compilação, então este import (e todo o código do servidor) nunca entra no bundle do browser.
// É um `import()` dinâmico e não `require()`: no bundle do servidor o axios (ESM) é externo, o que
// torna esses módulos "async" no webpack, e um `require()` síncrono deles devolve uma Promise.
if (typeof window === "undefined") {
  api.defaults.adapter = (config) =>
    import("@/server/http/in-process-adapter").then(({ default: inProcessAdapter }) => inProcessAdapter(config));
}

export default api;
